import * as React from 'react';

import ConfirmationCard from './components/ConfirmationCard';
import CheckoutCard from './components/CheckoutCard';
import ProductsList from './components/ProductsList';
import Summary from './components/Summary';
import Checkbox from 'src/components/common/Checkbox';
import Modal from 'src/components/common/Modal/Modal';
import SlideMenu from 'src/components/common/SlideMenu';
import PaymentMethodChange from './components/PaymentMethodChange';
import Alert from 'src/components/common/Alert';
import CreditCard from 'src/components/common/CreditCard';

import ItemModel from 'src/model/cartItem.model';
import LocationModel from 'src/model/location.model';
import UserModel from 'src/model/user.model';
import { IShippingMethod } from 'src/services/checkout/CheckoutService';
import CreditCardModel from 'src/model/creditCard.model';
import { ICheckoutError } from 'src/store/modules/checkout/reducers';

import { isMobile } from '../../utils/responsiveHelpers';
import './Checkout.scss';
import { ICartServiceItem } from 'src/services/cart/CartService';
import { goToCart } from 'src/utils/navigation';
import { whiteSpacesValidation as hasWhiteSpaces } from 'src/utils/whiteSpacesValidation';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface ICheckoutProps {
  isPending: boolean;
  orderConfirmed: boolean;
  creditCardUrl: string;
  allowedUserForExtraField: boolean;
  pendingOrderNumber: number;
  confirmationNumber: number;
  checkoutCode: number;
  items: { [key: number]: ItemModel };
  itemCount: number;
  deliverMethod: string;
  deliveryLocationCode: string;
  deliveryLocation: LocationModel;
  subtotal: string;
  tax: string;
  total: string;
  defaultMOT: string;
  termsOfDelivery: string;
  userData: UserModel;
  error: ICheckoutError;
  savedCreditCards: CreditCardModel[];
  selectedCreditCard: CreditCardModel;
  softCreditHold: boolean;
  onLoad: () => void;
  onPlaceOrder: (
    checkoutCode: number,
    confirmationEmail: boolean,
    deliverSameTime: boolean,
    paymentMethod: string,
    poNumber: string,
    shippingMethod: IShippingMethod,
    saveCard: boolean,
    technumber: string,
    servicenumber: string,
    unitnumber: string,
    mobileNumber: string,
    emailId: string,
    isOrderEmailPhoneUpdated: boolean,
    OrderTemprary:any
  ) => void;
  onConfirmOrder: (
    paymentConfirmation: string,
    pendingOrderId: number,
    mobileNumber: string,
    emailId: string,
    isOrderEmailPhoneUpdated: boolean,
    language: string,
    region: string,
    saveCard: boolean
  ) => void;
  onReorder(items: ICartServiceItem[], callback?: () => void): void;
  onSelectCreditCard(creditCard: CreditCardModel): void;
  onClosePoNumberAlert: () => void;
  deliveryStatus: any;
  t?: any;
  getPaymentMethodForCheckout(data: any): void;
}

interface ICheckoutState {
  emailConfirmation: boolean;
  deliverAllAtOnce: boolean;
  isMobile: boolean;
  showSlideMenu: boolean;
  showChangePaymentMethod: boolean;
  showCreditCard: boolean;
  paymentMethod: string;
  allowChangePaymentMethod: boolean;
  shippingMethod: IShippingMethod;
  PONumber: string;
  iframe: string;
  hardCreditHoldMsg: string;
  PONumberAlert: boolean;
  saveCard: boolean;
  unitNumber: string;
  serviceNumber: string;
  techNumber: string;
  mobileNumber: string;
  emailId:string;
  isOrderEmailPhoneUpdated: boolean;
  OrderTemprary:any;
  unitNumberAlert: boolean;
  serviceNumberAlert: boolean;
  serviceNumberFirstCharecterAlert: boolean;
  techNumberAlert: boolean;
  checkoutError: boolean;
}

class Checkout extends React.Component<ICheckoutProps, ICheckoutState> {
  constructor(props: any) {
    super(props);
    let OrderEmailPhoneUpdated = false;
     if(localStorage.getItem("isOrderEmailPhoneUpdated") === 'true') {
        OrderEmailPhoneUpdated = true;
     }

    this.state = {
      emailConfirmation: true,
      deliverAllAtOnce: this.props.deliveryStatus.deliverCompleteFlag,
      isMobile: isMobile(),
      showSlideMenu: false,
      showChangePaymentMethod: false,
      showCreditCard: false,
      paymentMethod: this.getDefaultPaymentMethod(),
      allowChangePaymentMethod: true,
      shippingMethod: {
        motcode: '',
        motdescription: ''
      },
      PONumber: '',
      unitNumber: '',
      serviceNumber: '',
      techNumber: this.getDefaultTechId(),
      iframe: '',
      PONumberAlert: false,
      unitNumberAlert: false,
      serviceNumberAlert: false,
      serviceNumberFirstCharecterAlert: false,
      techNumberAlert: false,
      mobileNumber: localStorage.getItem("orderPhone"),
      emailId: localStorage.getItem("orderEmail"),
      isOrderEmailPhoneUpdated: OrderEmailPhoneUpdated,
      OrderTemprary: '',
      checkoutError: false,
      saveCard: false,
      hardCreditHoldMsg: `${i18n.t('common.paymentOrderCannotBeProcessed')} ${
        env.REACT_APP_BASE_ENVIRONMENT === 'US'
          ? '1-800-841-4060.'
          : '1-866-985-5301.'
      }`
    };
  }

  public componentDidMount() {
    this.props.onLoad();

    if(sessionStorage.getItem("DeliveryCheck") === "checked") {
      this.setState({
        deliverAllAtOnce: true
      });
     } else if(sessionStorage.getItem("DeliveryCheck") === "unchecked") {
      this.setState({
        deliverAllAtOnce: false
      });
     } else {
      this.setState({
        deliverAllAtOnce: this.props.deliveryStatus.deliverCompleteFlag
      }); 
  
     }
  }

  public componentDidUpdate(prevProps: ICheckoutProps) {
    if (prevProps.userData !== this.props.userData) {
      this.setState({
        paymentMethod: this.getDefaultPaymentMethod()
      });
    }
    if (
      prevProps.deliveryStatus.deliverCompleteFlag !==
      this.props.deliveryStatus.deliverCompleteFlag
    ) {
      this.setState({
        deliverAllAtOnce: this.props.deliveryStatus.deliverCompleteFlag
      });


    }

  }

  private getDefaultPaymentMethod = (): string => {
    let defaultMethod: string = '001';
    if (this.props.userData && this.props.userData.paymentMethods) {
      let methodsAllowed: number = 0;
      this.props.userData.paymentMethods.forEach(paymentMethod => {
       
        if (paymentMethod.method === 'CREDIT CARD' && paymentMethod.active) {
          methodsAllowed++;
          if(this.props.savedCreditCards.length>0){
            defaultMethod = '004';  
          }else{
            defaultMethod = '002';
          }
        } else if (paymentMethod.method === 'ACCOUNT' && paymentMethod.active) {
          methodsAllowed++;
          defaultMethod = '001';
        }
      });

      if (methodsAllowed === 1) {
        this.setState({ allowChangePaymentMethod: false });
        return defaultMethod;
      } else {
        this.setState({ allowChangePaymentMethod: true });
        return '001';
      } 
    }

    return defaultMethod;
  };

  private placeOrder = () => {
    const activeAccount = localStorage.getItem('activeAccount');
    if (
      (localStorage.getItem('allowedUserForExtraField') === 'true' &&
        this.state.unitNumber === '') ||
      (localStorage.getItem('allowedUserForExtraField') === 'true' &&
        this.state.serviceNumber === '') ||
      (localStorage.getItem('allowedUserForExtraField') === 'true' && activeAccount!=="015411" &&
        this.state.techNumber === '')
    ) {
      this.setState({
        checkoutError: true
      });
    } else {
      if(sessionStorage.getItem("DeliveryCheck") === "checked") {
        this.setState({
          deliverAllAtOnce: true
        });
       } else if(sessionStorage.getItem("DeliveryCheck") === "unchecked") {
        this.setState({
          deliverAllAtOnce: false
        });
       }
      this.props.onPlaceOrder(
        this.props.checkoutCode,
        this.state.emailConfirmation,
        this.state.deliverAllAtOnce,
        this.state.paymentMethod,
        this.state.PONumber,
        this.state.shippingMethod,
        this.state.saveCard,
        this.state.unitNumber,
        this.state.serviceNumber,
        this.state.techNumber,
        this.state.mobileNumber,
        this.state.emailId,
        this.state.isOrderEmailPhoneUpdated,
        this.state.OrderTemprary
      );
      this.setState({
        unitNumberAlert: false,
        serviceNumberAlert: false,
        serviceNumberFirstCharecterAlert: false,
        techNumberAlert: false,
        checkoutError: false,
        PONumberAlert: false
      });
    }

    if (this.state.paymentMethod === '002') {
      this.setState({ showCreditCard: true });
    }

    this.setState({
      PONumberAlert: false
    });
    this.props.onClosePoNumberAlert();
    // log(this.props.error.hasFailed, '================');
    // console.log('this.props.error', this.props.error.message);
  };

  private reOrder = () => {
    // Re add items to cart
    const items = Object.keys(this.props.items).map(key => ({
      claims: this.props.items[key].claims,
      partNumber: this.props.items[key].productNumber,
      quantity: this.props.items[key].quantity,
      shipmentMarking: this.props.items[key].shipmentMarking,
      shipsfrom: this.props.items[key].shipsfromCode,
      warrantyProvider: this.props.items[key].warrantyProvider,
      rushOrder: this.props.items[key].rushOrder,
      ticketNumber: this.props.items[key].ticketNumber,
      delivery: this.props.deliverMethod,
      deliveryLocation: this.props.deliveryLocationCode
    }));
    // Go to cart
    this.props.onReorder(items, () => goToCart());
  };

  private handleEmailConfirmationChange = () => {
    this.setState(prevState => ({
      emailConfirmation: !prevState.emailConfirmation
    }));
  };

  private handleDeliverAllAtOnceChange = () => {
    this.setState(prevState => ({
      deliverAllAtOnce: !prevState.deliverAllAtOnce
    }));

      if(this.state.deliverAllAtOnce === true) { 
      sessionStorage.setItem("DeliveryCheck",'unchecked');
   
      } else if(this.state.deliverAllAtOnce === false) { 
        sessionStorage.setItem("DeliveryCheck",'checked');
      }
  };

  private handleShowChangePaymentMethod = () => {
    this.setState({ showSlideMenu: true, showChangePaymentMethod: true });
    window.scrollTo(0, 0);
  };

  private handleCloseSlideMenu = () => {
    this.setState({
      showSlideMenu: false
    });
  };

  private handleCloseChangePaymentMethod = () => {
    this.setState({
      showChangePaymentMethod: false
    });
  };

  private handleSuccessCreditCard = () => {
    const n = this.props.creditCardUrl.indexOf('uID=');
    const uID = this.props.creditCardUrl.substring(n + 4);
    let OrderEmailPhoneUpdated = false;
    if(localStorage.getItem("isOrderEmailPhoneUpdated") === 'true') {
      OrderEmailPhoneUpdated = true;
    }
    
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
    this.props.onConfirmOrder(
      uID,
      this.props.pendingOrderNumber,
      '',
      '',
      OrderEmailPhoneUpdated,
      languageFromUrl,
      region,
      this.state.saveCard
    );
    this.setState({
      showCreditCard: false,
      saveCard: false
    });
  };

  private handleCancelCreditCard = () => {
    this.setState({
      showCreditCard: false,
      saveCard: false
    });
  };

  private handlePaymentMethodSave = (paymentMethod: string) => {
    if (paymentMethod !== '002') {
      // 002 is credit card method
      this.setState({
        paymentMethod,
        showChangePaymentMethod: false,
        showSlideMenu: false,
        showCreditCard: false,
        saveCard: false
      });
    } else {
      this.setState({
        paymentMethod,
        showChangePaymentMethod: false,
        showSlideMenu: false
      });
    }
    this.props.getPaymentMethodForCheckout(paymentMethod);
  };

  private handleSelectShippingMethodChange = (
    shippingMethod: IShippingMethod
  ) => {
    this.setState({ shippingMethod });
  };

  private handlePONumberChange = (PONumber: string) => {
    const poNumberClean = !hasWhiteSpaces(PONumber)
      ? PONumber
      : PONumber.replace(/\s/g, '');

    if (poNumberClean.length > 15) {
      this.setState({
        PONumberAlert: true
      });
    } else {
      this.setState({
        PONumberAlert: false
      });
      this.setState({ PONumber: poNumberClean });
    }
  };

  private handleUnitNumberChange = (unit: string) => {
    const activeAccount = localStorage.getItem('activeAccount');
    if(activeAccount==="015411"){
      const unitNumberClean = unit.replace(/\D/g, '');

      if (unitNumberClean.length > 6) {
        this.setState({
          unitNumberAlert: true
        });
      } else {
        this.setState({
          unitNumberAlert: false
        });
        this.setState({ unitNumber: unitNumberClean });
      }

    }else{

      const unitNumberClean = !hasWhiteSpaces(unit)
      ? unit
      : unit.replace(/\s/g, '');

    if (unitNumberClean.length > 6) {
      this.setState({
        unitNumberAlert: true
      });
    } else {
      this.setState({
        unitNumberAlert: false
      });
      this.setState({ unitNumber: unitNumberClean });
    }

    }
   
  };

  private getDefaultTechId = () => {
    const activeAccount = localStorage.getItem('activeAccount');
    let techIdDefaultVal= '';
    if(activeAccount==="015411"){
      techIdDefaultVal='0000000';
     return techIdDefaultVal;
    }else{
      techIdDefaultVal='';
     return techIdDefaultVal;    

    }
  };

  private handleServicetNumberChange = (service: string) => {
    const activeAccount = localStorage.getItem('activeAccount');
    if(activeAccount==="015411"){
      const serviceNumberClean = service.replace(/\D/g, '');
    const firstNumber=serviceNumberClean.charAt(0);
    if (serviceNumberClean.length > 8) {
      this.setState({
        serviceNumberAlert: true
      });
    } else {
      this.setState({
        serviceNumberAlert: false
      });
      this.setState({ serviceNumber: serviceNumberClean });
    }
    }else{
    const serviceNumberClean = !hasWhiteSpaces(service)
      ? service
      : service.replace(/\s/g, '');

    if (serviceNumberClean.length > 8) {
      this.setState({
        serviceNumberAlert: true
      });
    } else {
      this.setState({
        serviceNumberAlert: false
      });
      this.setState({ serviceNumber: serviceNumberClean });
    }
  }
  };

  private handleTechNumberChange = (techID: any) => {
    const techIDNumberClean = !hasWhiteSpaces(techID)
      ? techID
      : techID.replace(/\s/g, '');

    if (techIDNumberClean.length > 10) {
      this.setState({
        techNumberAlert: true
      });
    } else {
      this.setState({
        techNumberAlert: false
      });
      this.setState({ techNumber: techIDNumberClean });
    }
  };

  private handleSaveCardChange = () => {
    this.setState(prevState => ({
      saveCard: !prevState.saveCard
    }));
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public render() {

    // console.log("CheckedDeliveryStatus",sessionStorage.getItem("DeliveryCheck"));
    // console.log("defultDeliveryStatus",this.state.deliverAllAtOnce);

    const softMessage = `${i18n.t('common.orderPlacedAndReviewed')} ${
      env.REACT_APP_BASE_ENVIRONMENT === 'US'
        ? '800-841-4060'
        : '1-866-985-5301'
    } ${i18n.t('common.discussDetailsOfAccount')}`;
    const { t } = this.props;
    const activeAccount = localStorage.getItem('activeAccount');
    return (
      <div className="rp-checkout Roboto">
        {this.props.isPending ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
          <React.Fragment>
            {this.state.isMobile ? (
              <SlideMenu
                mounted={this.state.showSlideMenu}
                goBackTitle={t('common.back')}
                level={2 + 30}
                handleCloseMenu={this.handleCloseSlideMenu}
              >
                {this.state.showChangePaymentMethod && (
                  <PaymentMethodChange
                    account={this.props.userData.accountId}
                    savedPaymentMethod={this.state.paymentMethod}
                    handleClose={this.handleCloseChangePaymentMethod}
                    handlePaymentMethodSave={this.handlePaymentMethodSave}
                    savedCreditCards={this.props.savedCreditCards.length}
                  />
                )}
              </SlideMenu>
            ) : (
              this.state.showChangePaymentMethod && (
                <Modal handleCloseModal={this.handleCloseChangePaymentMethod}>
                  <PaymentMethodChange
                    account={this.props.userData.accountId}
                    // TO DO: change credit card
                    savedPaymentMethod={this.state.paymentMethod}
                    handleClose={this.handleCloseChangePaymentMethod}
                    handlePaymentMethodSave={this.handlePaymentMethodSave}
                    savedCreditCards={this.props.savedCreditCards.length}
                  />
                </Modal>
              )
            )}
            <div className="rp-checkout--title">
              {t('cartPage.breadCrumb')}{' '}
              <span>
                {this.props.itemCount} {t('common.items_plural')}
              </span>
            </div>
            <div className="rp-checkout--checkout-alert">
              {this.state.PONumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxPoCharacterErr', {
                      count: 15
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      PONumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )}

                {activeAccount === '015411' && this.state.unitNumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxUnitNumberErr', {
                      count: 6
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      unitNumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )} 

               {activeAccount === '015411' && this.state.serviceNumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxSeviceNumberErr', {
                      count: 8
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      serviceNumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )} 

               {activeAccount === '015411' && this.state.serviceNumberFirstCharecterAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    `${t('productFieldErrors.firstCharSeviceNumberErr', {
                      count: 8
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      serviceNumberFirstCharecterAlert: false
                    });
                  }}
                  type={'error'}
                />
              )} 

              {(activeAccount === '015089' || activeAccount === '015411') && this.state.checkoutError && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.checkOutError', {
                      count: 6
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      checkoutError: false
                    });
                  }}
                  type={'error'}
                />
              )}
              {activeAccount === '015089' && this.state.unitNumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxUnitCharacterErr', {
                      count: 6
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      unitNumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )}
              {activeAccount === '015089' && this.state.serviceNumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxSeviceCharacterErr', {
                      count: 8
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      serviceNumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )}
              {activeAccount === '015089' && this.state.techNumberAlert && (
                <Alert
                  styleClass="errorPoNumberAlert"
                  message={
                    // 'Maximum allowable length for PO Number is 15 characters'
                    `${t('productFieldErrors.maxTechCharacterErr', {
                      count: 10
                    })}`
                  }
                  icon={'rpds-error'}
                  handleCloseAlert={() => {
                    this.setState({
                      techNumberAlert: false
                    });
                  }}
                  type={'error'}
                />
              )}
            </div>
            <div className="rp-checkout-info">
              <div
                className={
                  env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                    ? `rp-checkout--secondary rp-checkout--secondary-CA-version`
                    : `rp-checkout--secondary`
                }
              >
                {this.state.isMobile && this.props.orderConfirmed && (
                  <ConfirmationCard
                    confirmationNumber={this.props.confirmationNumber}
                    items={this.props.items}
                    userData={this.props.userData}
                    deliverMethod={this.props.deliverMethod}
                    orderConfirmed={this.props.orderConfirmed}
                    deliveryLocation={this.props.deliveryLocation}
                    termsOfDelivery={this.props.termsOfDelivery}
                    PONumber={this.state.PONumber}
                    shippingMethod={this.state.shippingMethod}
                    paymentMethod={this.state.paymentMethod}
                    selectedCreditCard={this.props.selectedCreditCard}
                    emailConfirmation={this.state.emailConfirmation}
                    total={this.props.total}
                    subtotal={this.props.subtotal}
                    taxTotal={this.props.tax}
                  />
                )}

                <Summary
                  orderConfirmed={this.props.orderConfirmed}
                  subtotal={Number(this.props.subtotal)}
                  taxTotal={Number(this.props.tax)}
                  total={Number(this.props.total)}
                  placeOrder={this.placeOrder}
                  reOrder={this.reOrder}
                  hasFailed={this.props.error.hasFailed}
                />

                {!this.props.orderConfirmed && (
                  <div className="rp-checkout--email-confirmation">
                    <div className='receiveEmailNote'>
                      <span style={{fontWeight:'bold'}}>{t('payment.check.note')}</span> {t('accountInfo.accountOrderConfirmationEmailNotification')}
                    </div>
                    <span style={{display:'none'}}>
                    <Checkbox
                      name={t('checkoutPage.wouldLikeToReceive')}
                      value={'emailConfirmation'}
                      checked={this.state.emailConfirmation}
                      onChange={this.handleEmailConfirmationChange}
                    />
                    </span>
                  </div>
                )}
                <CreditCard
                  show={
                    this.state.showCreditCard &&
                    this.props.creditCardUrl !== null
                  }
                  onSuccess={this.handleSuccessCreditCard}
                  onCancel={this.handleCancelCreditCard}
                  creditCardUrl={this.props.creditCardUrl}
                  saveCard={this.state.saveCard}
                  onSaveCard={this.handleSaveCardChange}
                />
              </div>
              <div className="rp-checkout--main">
                {!this.state.isMobile && this.props.orderConfirmed && (
                  <ConfirmationCard
                    confirmationNumber={this.props.confirmationNumber}
                    items={this.props.items}
                    userData={this.props.userData}
                    deliverMethod={this.props.deliverMethod}
                    orderConfirmed={this.props.orderConfirmed}
                    deliveryLocation={this.props.deliveryLocation}
                    termsOfDelivery={this.props.termsOfDelivery}
                    PONumber={this.state.PONumber}
                    shippingMethod={this.state.shippingMethod}
                    paymentMethod={this.state.paymentMethod}
                    selectedCreditCard={this.props.selectedCreditCard}
                    emailConfirmation={this.state.emailConfirmation}
                    total={this.props.total}
                    subtotal={this.props.subtotal}
                    taxTotal={this.props.tax}
                  />
                )}
                <div className="rp-checkout--checkout-alert">
                  {this.props.error.hasFailed && (
                    <Alert
                      styleClass="errorCheckoutAlert"
                      message={
                        this.props.error.message ===
                        "Couldn't Confirm Order. Failed due to Hard credit hold"
                          ? this.state.hardCreditHoldMsg
                          : this.props.error.message
                      }
                      icon={'rpds-error'}
                      handleCloseAlert={() => {
                        return;
                      }}
                      type={'error'}
                    >
                      <a onClick={this.props.onLoad} className="reloadLink">
                        {t('common.reload')}
                      </a>
                    </Alert>
                  )}
                </div>
                <div className="rp-checkout--checkout-alert">
                  {/* { activeAccount === '015089' && !this.props.error.hasFailed && (
                    
                  )
                  
                  } */}
                  {this.props.softCreditHold && !this.props.error.hasFailed && (
                    <Alert
                      styleClass="errorBigCheckoutAlert"
                      message={softMessage}
                      icon={'rpds-warning'}
                      handleCloseAlert={() => {
                        return;
                      }}
                      type={'warning'}
                    >
                      <a onClick={this.props.onLoad} className="reloadLink">
                        {t('common.reload')}
                      </a>
                    </Alert>
                  )}
                </div>
                <CheckoutCard
                  ponumberRequired={this.props.userData.ponumberRequired}
                  orderConfirmed={this.props.orderConfirmed}
                  accountId={this.props.userData.accountId}
                  name={this.props.userData.name}
                  email={this.props.userData.email}
                  flagnewfields={this.props.allowedUserForExtraField}
                  phone={this.props.userData.mobileNumber}
                  itemsQty={this.props.itemCount}
                  deliverMethod={this.props.deliverMethod}
                  deliveryLocation={this.props.deliveryLocation}
                  items={this.props.items}
                  deliverAllAtOnce={this.state.deliverAllAtOnce}
                  paymentMethod={this.state.paymentMethod}
                  allowChangePaymentMethod={this.state.allowChangePaymentMethod}
                  defaultShippingMethod={this.props.defaultMOT}
                  shippingMethod={this.state.shippingMethod}
                  termsOfDelivery={this.props.termsOfDelivery}
                  PONumber={this.state.PONumber}
                  savedCreditCards={this.props.savedCreditCards}
                  selectedCreditCard={this.props.selectedCreditCard}
                  handleDeliverAllAtOnceChange={
                    this.handleDeliverAllAtOnceChange
                  }
                  handleShowChangePaymentMethod={
                    this.handleShowChangePaymentMethod
                  }
                  handleSelectShippingMethodChange={
                    this.handleSelectShippingMethodChange
                  }
                  handlePONumberChange={this.handlePONumberChange}
                  handlePaymentMethodSave={this.handlePaymentMethodSave}
                  handleSelectCreditCard={this.props.onSelectCreditCard}
                  softCreditHold={this.props.softCreditHold}
                  stateUnitNumber={this.state.unitNumber}
                  stateServiceNumber={this.state.serviceNumber}
                  stateTechId={this.state.techNumber}
                  handleAllUnitNumberChange={this.handleUnitNumberChange}
                  handleAllServiceNumberChange={this.handleServicetNumberChange}
                  handleAllTechIdNumberChange={this.handleTechNumberChange}
                />
                <ProductsList
                  orderConfirmed={this.props.orderConfirmed}
                  items={this.props.items}
                  deliverMethod={this.props.deliverMethod}
                  deliveryLocation={this.props.deliveryLocation}
                />
              </div>
              <div
                className={
                  env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                    ? `rp-checkout--secondary rp-checkout--secondary-CA-version mobile-view-only`
                    : `rp-checkout--secondary mobile-view-only`
                }
              >
                {this.state.isMobile && this.props.orderConfirmed && (
                  <ConfirmationCard
                    confirmationNumber={this.props.confirmationNumber}
                    items={this.props.items}
                    userData={this.props.userData}
                    deliverMethod={this.props.deliverMethod}
                    orderConfirmed={this.props.orderConfirmed}
                    deliveryLocation={this.props.deliveryLocation}
                    termsOfDelivery={this.props.termsOfDelivery}
                    PONumber={this.state.PONumber}
                    shippingMethod={this.state.shippingMethod}
                    paymentMethod={this.state.paymentMethod}
                    selectedCreditCard={this.props.selectedCreditCard}
                    emailConfirmation={this.state.emailConfirmation}
                    total={this.props.total}
                    subtotal={this.props.subtotal}
                    taxTotal={this.props.tax}
                  />
                )}
                <Summary
                  orderConfirmed={this.props.orderConfirmed}
                  subtotal={Number(this.props.subtotal)}
                  taxTotal={Number(this.props.tax)}
                  total={Number(this.props.total)}
                  placeOrder={this.placeOrder}
                  reOrder={this.reOrder}
                  hasFailed={this.props.error.hasFailed}
                />
                {!this.props.orderConfirmed && (
                  <div className="rp-checkout--email-confirmation">
                    <div className='receiveEmailNote'>
                      <span style={{fontWeight:'bold'}}>{t('payment.check.note')}</span>{t('accountInfo.accountOrderConfirmationEmailNotification')}
                    </div>
                    <span style={{display:'none'}}>
                    <Checkbox
                      name={t('checkoutPage.wouldLikeToReceive')}
                      value={'emailConfirmation'}
                      checked={this.state.emailConfirmation}
                      onChange={this.handleEmailConfirmationChange}
                    />
                    </span>
                  </div>
                )}
                <CreditCard
                  show={
                    this.state.showCreditCard &&
                    this.props.creditCardUrl !== null
                  }
                  onSuccess={this.handleSuccessCreditCard}
                  onCancel={this.handleCancelCreditCard}
                  creditCardUrl={this.props.creditCardUrl}
                  saveCard={this.state.saveCard}
                  onSaveCard={this.handleSaveCardChange}
                />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Checkout;
